
import { ArrowRight, BadgeCheck, BriefcaseBusiness, Headphones, HeartHandshake, Users } from 'lucide-react'
import { Link } from 'react-router-dom'

export function Teams(){return <>
  <section className="public-page-hero public-container">
    <span className="public-kicker">Teams</span>
    <h1>For teams where customer communication happens in email.</h1>
    <p>
      Use Mail Percent across sales, support, customer success and other teams that rely on email to respond to prospects and existing customers.
    </p>
  </section>

  <section className="public-section public-container">
    <div className="public-feature-grid two">
      <article className="public-usecase-card">
        <BriefcaseBusiness/>
        <div>
          <span>Sales & enquiries</span>
          <h3>Keep warm leads from going cold.</h3>
          <p>See how quickly new opportunities are picked up, where replies stall and where follow-up gaps are putting potential conversions at risk.</p>
        </div>
      </article>

      <article className="public-usecase-card">
        <Headphones/>
        <div>
          <span>Customer support</span>
          <h3>Keep support response visible.</h3>
          <p>See backlog, response times and SLA Performance together so service gaps can be fixed before they become a poor customer experience.</p>
        </div>
      </article>

      <article className="public-usecase-card">
        <HeartHandshake/>
        <div>
          <span>Customer success & account teams</span>
          <h3>Keep account follow-through visible.</h3>
          <p>Track follow-through across ongoing customer conversations and see where account communication is slowing down.</p>
        </div>
      </article>

      <article className="public-usecase-card">
        <Users/>
        <div>
          <span>Managers & team leaders</span>
          <h3>Get accountability without losing operating context.</h3>
          <p>See who is handling customer email, what remains open and where standards are being missed while keeping demand, backlog and capacity visible.</p>
        </div>
      </article>
    </div>
  </section>

  <section className="public-section public-soft-section">
    <div className="public-container">
      <div className="public-section-heading">
        <span className="public-kicker">Accountability with context</span>
        <h2>Hold the communication standard without ignoring the workload.</h2>
        <p>Mail Percent keeps your organisation’s response standard and the conditions your team was working under visible at the same time.</p>
      </div>

      <div className="public-context-comparison">
        <div><small>Customer response SLA</small><strong>First reply ≤ 30m</strong><span><BadgeCheck/>Clear expectation</span></div>
        <div className="context-plus">+</div>
        <div><small>Operating conditions</small><strong>27 waiting · 4 active people</strong><span><Users/>Workload context</span></div>
      </div>
    </div>
  </section>

  <section className="public-section public-container public-final-cta">
    <div>
      <span className="public-kicker">Make customer email accountable</span>
      <h2>Give managers a clearer view of workload, follow-through and response standards.</h2>
    </div>
    <Link to="/signup" className="button primary public-cta">Get started <ArrowRight size={16}/></Link>
  </section>
</>}
